/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './css/DayMinPriceLoader.css';

function DayMinPriceLoader() {
  return (
    <div className="dmp_w">
      <div className="dmp_item">
        <div className="dmp_price">
          <div className="mb_8">
            <Skeleton width="68px" height="19px" />
          </div>
          <Skeleton width="85px" height="16px" />
        </div>
      </div>
      <div className="dmp_item">
        <div className="dmp_price">
          <div className="mb_8">
            <Skeleton width="68px" height="19px" />
          </div>
          <Skeleton width="85px" height="16px" />
        </div>
      </div>
      <div className="dmp_item">
        <div className="dmp_price">
          <div className="mb_8">
            <Skeleton width="68px" height="19px" />
          </div>
          <Skeleton width="85px" height="16px" />
        </div>
      </div>
      <div className="dmp_item">
        <div className="dmp_price">
          <div className="mb_8">
            <Skeleton width="68px" height="19px" />
          </div>
          <Skeleton width="85px" height="16px" />
        </div>
      </div>
      <div className="dmp_item">
        <div className="dmp_price">
          <div className="mb_8">
            <Skeleton width="68px" height="19px" />
          </div>
          <Skeleton width="85px" height="16px" />
        </div>
      </div>
    </div>
  );
}

export default DayMinPriceLoader;
